import { useNotificationStore } from '../../stores/notificationStore';
import { NotificationCard } from './NotificationCard';

export const NotificationContainer = () => {
  const { notifications } = useNotificationStore();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map((notification) => (
        <NotificationCard 
          key={notification.id} 
          notification={notification} 
        />
      ))}
    </div>
  );
};